import { Pagination } from '@calendly/ui/components/pagination';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingState from 'components/core/loading_state';
import { ApplyManagedEventsPopup } from 'features/managed_event_types';
import { useQueryParams } from 'hooks/use_query_params';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
import { BatchControls } from '../batch_controls';
import { ControlsContainer } from '../controls_container';
import { ActiveBatchControls } from './active_batch_controls';
import { ChangeRolePopup } from './change_role_popup';
import { filterTermSelector, isChangeRolePopupOpenSelector, isLoadingSelector, membershipsSelector, paginationSelector, selectedEntitiesCountSelector } from './selectors';
import { clearSelection, initPage, search, updatePage, resetState } from './slice';
import { ActiveUsersTable } from './table';
const paginationContainerCss = "p1cfyxvl";
const PaginationContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paginationContainerCss, props.className)} />;
});
export const ActiveUsers = () => {
  const dispatch = useDispatch();
  const {
    page
  } = useQueryParams();
  const pagination = useSelector(paginationSelector);
  const memberships = useSelector(membershipsSelector);
  const isLoading = useSelector(isLoadingSelector);
  const isChangeRolePopupOpen = useSelector(isChangeRolePopupOpenSelector);
  const selectionCount = useSelector(selectedEntitiesCountSelector);
  const anySelectedEntities = selectionCount > 0;
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const handleSearch = query => dispatch(search(query));
  const filterTerm = useSelector(filterTermSelector);
  const isDesktopUp = useDeviceType('isDesktopUp');
  useEffect(() => {
    dispatch(initPage());
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);
  useEffect(() => {
    if (!isLoading && page && page > 1 && memberships.length === 0) {
      dispatch(updatePage({
        page: 1
      }));
    }
  }, [dispatch, memberships, page, isLoading]);
  return <>
      {anySelectedEntities && isAdminOrOwner && isDesktopUp && <BatchControls selectionCount={selectionCount} onClose={() => dispatch(clearSelection())}>
          <ActiveBatchControls />
        </BatchControls>}
      {!anySelectedEntities && <ControlsContainer filterTerm={filterTerm} handleSearch={handleSearch} isAdminOrOwner={isAdminOrOwner} />}
      {isLoading && <LoadingState />}
      {!isLoading && <>
          <ActiveUsersTable memberships={memberships} />
          <PaginationContainer>
            <Pagination {...pagination} onPageClick={nextPage => dispatch(updatePage({
          page: nextPage
        }))} />
          </PaginationContainer>
        </>}
      {isChangeRolePopupOpen && <ChangeRolePopup />}
      <ApplyManagedEventsPopup />
    </>;
};

require("./active_users.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./active_users.js");